const API_BASE = '/api';
const TOKEN_KEY = 'einsam_editor_token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function login(email: string, password: string): Promise<string> {
  const res = await fetch(`${API_BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Anmeldung fehlgeschlagen.');
  }
  const data = await res.json();
  return data.token as string;
}

/** einsam backend returns the raw content object (not wrapped in { content }). */
export async function fetchContent(): Promise<Record<string, unknown>> {
  const res = await fetch(`${API_BASE}/content`);
  if (!res.ok) throw new Error('Inhalte konnten nicht geladen werden.');
  return (await res.json()) as Record<string, unknown>;
}

export async function saveContent(content: unknown): Promise<void> {
  const res = await fetch(`${API_BASE}/content`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken() ?? ''}`,
    },
    body: JSON.stringify(content),
  });
  if (res.status === 401) {
    clearToken();
    throw new Error('Sitzung abgelaufen – bitte erneut anmelden.');
  }
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Speichern fehlgeschlagen.');
  }
}

/** Upload an image as a data-URL; returns the public URL to store in content. */
export async function uploadImage(dataUrl: string): Promise<string> {
  const res = await fetch(`${API_BASE}/upload`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken() ?? ''}`,
    },
    body: JSON.stringify({ dataUrl }),
  });
  if (res.status === 401) {
    clearToken();
    throw new Error('Sitzung abgelaufen – bitte erneut anmelden.');
  }
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Bild konnte nicht hochgeladen werden.');
  }
  const data = await res.json();
  return data.url as string;
}

export async function forgotPassword(): Promise<string | undefined> {
  const res = await fetch(`${API_BASE}/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'E-Mail konnte nicht gesendet werden.');
  }
  const data = await res.json().catch(() => ({}));
  return data.sentTo as string | undefined;
}

export async function resetPassword(token: string, newPassword: string): Promise<void> {
  const res = await fetch(`${API_BASE}/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, newPassword }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Passwort konnte nicht zurückgesetzt werden.');
  }
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  const res = await fetch(`${API_BASE}/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken() ?? ''}`,
    },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  if (res.status === 401) {
    clearToken();
    throw new Error('Sitzung abgelaufen – bitte erneut anmelden.');
  }
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Passwort konnte nicht geändert werden.');
  }
}
